import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ session, loading, children }) => {
  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', background: '#0f1117',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <div style={{ color: '#00D2C8', fontSize: '14px' }}>Betöltés...</div>
      </div>
    );
  }
  if (!session) return <Navigate to="/login" replace />;
  return children;
};

export default ProtectedRoute;
